<div class="legal-container">
  <h1>Términos de Servicio</h1>
  <p>Al utilizar Innovadoc IA, aceptas los siguientes términos y condiciones:</p>
  <ul>
    <li>El uso de la plataforma es bajo tu propio riesgo.</li>
    <li>No nos hacemos responsables por daños derivados del uso del servicio.</li>
    <li>Nos reservamos el derecho de modificar estos términos en cualquier momento.</li>
    <li>Debes respetar las leyes y regulaciones aplicables.</li>
  </ul>
  <h2>Contacto</h2>
  <p>Para consultas sobre los términos, contáctanos en <a href="mailto:soporte@innovadoc-ia.com">soporte&#64;innovadoc-ia.com</a>.</p>
</div>
